import React from 'react';
import { Field, useField } from 'formik';
import { Switch as ShadSwitch } from '@dashboard/components/ui/switch';
import { Label } from '@dashboard/components/ui/label';

export default function Switch({ name, id, label, description, value, required, onChange }) {
  const switchId = id || name;
  return (
    <div className="flex items-center justify-between gap-x-4 flex-1">
      {label && (
        <span className="flex-grow flex flex-col">
          <Label
            htmlFor={switchId}
            className="text-sm font-medium text-gray-900 dark:text-foreground"
          >
            {label}
          </Label>
          {description && (
            <span className="text-gray-700 dark:text-muted-foreground text-sm">{description}</span>
          )}
        </span>
      )}

      <ShadSwitch
        id={switchId}
        name={name}
        checked={Boolean(value)}
        required={required}
        onCheckedChange={next => onChange(name, next)}
      />
    </div>
  );
}

export const SwitchField = props => {
  const [field, , helpers] = useField(props);
  const { setValue } = helpers;

  const onChange = (name, next) => {
    setValue(next);
    if (props.onChange) props.onChange(next);
  };

  return <Field {...props} as={Switch} onChange={onChange} value={field.value} />;
};
